import { loadUrlReducer } from '../../url/reducers/UrlReducer';
import urlSaga from '../../url/sagas/UrlSagas';
const loadUrlModule = (initialData) => ({
    id: 'Url',
    reducerMap: {
        url: loadUrlReducer(initialData ? initialData.url : null),
    },
    sagas: [urlSaga],
});
export default loadUrlModule;
